import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { authSelectors } from '@rosetta/react-auth';

import { appTextColor, white, superLightGrey, black, blueEnabledColor } from '../../../styles/colors';
import { lionSelectors, LionTranslate } from '@rosetta/react-lion/dist/index';
import { LaunchpadButton } from '../../../styles/LaunchpadButton';
import { LinkButton } from '../../../styles/LinkButton';
import { RSDropdown } from '@rosetta/rs-dropdown';
import { menuStyle } from '../../../styles/LaunchpadCompactDropdownStyle';
import { goalsDayOptions, goalsMinutesOptions } from '../services/goals-helpers';
import { goalsActions } from '../reducer/goals-reducer';
import { withWindowDimensions } from '@rosetta/react-common-ui';
import { isMobile as isMobileDetected } from 'react-device-detect';

const GoalHeader = styled.div((props) => {
  let style = {
    fontSize: !props.isMobile ? '36px' : '18px',
    lineHeight: !props.isMobile ? '48px' : '24px',
    textAlign: 'left',
    fontWeight: '200',
    paddingBottom: !props.isMobile ? '19px' : '9px'
  };
  return style;
});

const TriggerButtonsContainer = styled.div((props) => {
  let style = {
    textAlign: 'center',
    margin: '0 auto'
  };
  return style;
});

const FieldWrapper = styled.div((props) => {
  let style = {
    display: 'block',
    height: !props.isMobile ? '67px' : 'auto'
  };

  return style;
});

const DropdownWrapper = styled.div((props) => {
  let style = {
    width: !props.isMobile ? '80px' : 'auto',
    float: !props.isMobile ? 'right' : 'none',
    height: '40px',
    color: appTextColor
  };

  return style;
});

const FieldLabel = styled.div((props) => {
  let style = {
    float: !props.isMobile ? 'left' : 'none',
    fontSize: !props.isMobile ? '15px' : '12px',
    lineHeight: '40px',
    textAlign: 'left',
    marginTop: '0px',
    marginBottom: '5px',
    color: appTextColor,
    verticalAlign: 'top'
  };

  return style;
});

const CancelButton = styled(LaunchpadButton)((props) => {
  let style = {
    backgroundColor: white,
    border: '1px solid ' + superLightGrey,
    color: !props.isMobile ? black : blueEnabledColor,
    float: !props.isMobile ? 'left' : 'none',
    paddingLeft: '20px',
    paddingRight: '20px',
    marginBottom: !props.isMobile ? '30px' : '0',
    width: !props.isMobile ? '120px' : 'auto',
    fontSize: !props.isMobile ? '16px' : '13px',
    ':hover': {
      backgroundColor: white,
      border: '1px solid ' + black
    }
  };

  if (props.isMobile) {
    style.border = 'none';
    style.fontSize = '13px';
  }
  return style;
});

const TriggerButton = styled(LaunchpadButton)((props) => {
  let style = {
    float: !props.isMobile ? 'right' : 'none',
    paddingLeft: '20px',
    paddingRight: '20px',
    fontSize: '16px',
    width: !props.isMobile ? '165px' : 'auto',
    marginBottom: !props.isMobile ? '30px' : '0'
  };
  if (props.isMobile) {
    style.borderRadius = '4px';
    style.marginTop = '20px';
  }
  return style;
});

const DismissButton = styled(LinkButton)((props) => {
  let style = {
    position: 'absolute',
    right: '25px',
    top: '20px',
    color: appTextColor,
    fontSize: !props.isMobile ? '25px' : '16px'
  };
  return style;
});

const TriggerBox = styled.div((props) => {
  let style = {
    position: !props.isMobile ? 'absolute' : 'fixed',
    left: !props.isMobile ? '37%' : '16px',
    top: !props.isMobile ? '20%' : '66px',
    padding: !props.isMobile ? '40px 50px 10px' : '16px',
    zIndex: '999',
    backgroundColor: white,
    color: appTextColor,
    borderRadius: '4px',
    minHeight: '200px'
  };
  if (!props.isMobile) {
    style.width = '400px';
  } else {
    style.right = '16px';
  }
  return style;
});

//*********************************************
class EditGoalsModal extends PureComponent {
  componentWillMount = () => {};

  constructor(props) {
    super(props);

    this.state = {
      goalDays: (this.props.userInfo.usageGoalDays ? this.props.userInfo.usageGoalDays : 3).toString(),
      goalMinutes: (this.props.userInfo.usageGoalMinutes ? this.props.userInfo.usageGoalMinutes : 60).toString()
    };
  }

  handleUpdatedGoalDays = (daysObj) => {
    this.setState({ goalDays: daysObj.value });
  };

  handleUpdatedGoalMinutes = (hoursObj) => {
    this.setState({ goalMinutes: hoursObj.value });
  };

  handleSaveChangesButtonClick = (event) => {
    this.forceUpdate(() => {
      const updatedGoals = {
        usageGoalDays: this.state.goalDays,
        usageGoalMinutes: this.state.goalMinutes
      };
      this.props.updateGoals(updatedGoals);
    });
  };

  /*
    render!
  */
  render = () => {
    const isMobile = isMobileDetected;
    let closeButton = (
      <DismissButton onClick={() => this.props.setGoalsPopupView(false)} isMobile={isMobile}>
        &#x2715;
      </DismissButton>
    );
    let editGoalsForm = null;
    //if (this.props.showDatePicker) {
    editGoalsForm = (
      <TriggerBox isMobile={isMobile}>
        {closeButton}
        <GoalHeader isMobile={isMobile}>
          <LionTranslate lionkey="edit_my_goals" />
        </GoalHeader>

        <FieldWrapper isMobile={isMobile}>
          <FieldLabel isMobile={isMobile}>
            <LionTranslate lionkey="goals_weekly_logins" />
          </FieldLabel>
          <DropdownWrapper isMobile={isMobile}>
            <RSDropdown
              dataQa="todo"
              itemsList={goalsDayOptions}
              itemDisplayProperty="value"
              itemKeyProperty="value"
              onSelectionHandler={this.handleUpdatedGoalDays}
              selectedKey={this.state.goalDays}
              menuTabIndex={1}
              menuStyle={menuStyle}
            />
          </DropdownWrapper>
        </FieldWrapper>

        <FieldWrapper isMobile={isMobile}>
          <FieldLabel isMobile={isMobile}>
            <LionTranslate lionkey="goals_minutes_per_day" />
          </FieldLabel>
          <DropdownWrapper isMobile={isMobile}>
            <RSDropdown
              dataQa="todo"
              itemsList={goalsMinutesOptions}
              itemDisplayProperty="value"
              itemKeyProperty="value"
              onSelectionHandler={this.handleUpdatedGoalMinutes}
              selectedKey={this.state.goalMinutes}
              menuTabIndex={1}
              menuStyle={menuStyle}
            />
          </DropdownWrapper>
        </FieldWrapper>

        <TriggerButtonsContainer>
          <TriggerButton onClick={() => this.handleSaveChangesButtonClick()} isMobile={isMobile}>
            <LionTranslate lionkey="profile_button_savechanges" />
          </TriggerButton>
          <CancelButton onClick={() => this.props.setGoalsPopupView(false)} isMobile={isMobile}>
            <LionTranslate lionkey="forgotpassword_cancel_link" />
          </CancelButton>
        </TriggerButtonsContainer>
      </TriggerBox>
    );
    //}

    return <div>{editGoalsForm}</div>;
  };
}

EditGoalsModal.propTypes = {};

const mapStateToProps = (state, ownprops) => ({
  lionTranslateString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  },
  currentLocale: lionSelectors.getLionLanguage(state),
  userInfo: authSelectors.userInfo(state)
});

const wrapActions = {
  setGoalsPopupView: goalsActions.setGoalsPopupView,
  updateGoals: goalsActions.updateGoals
};
export const EditGoalsContainer = connect(
  mapStateToProps,
  wrapActions
)(withWindowDimensions(EditGoalsModal));



// WEBPACK FOOTER //
// ./src/modules/launchpad/components/EditGoals.jsx